export default {"src":"/_next/static/media/Case-Study-Icon.d8eb07d0.svg","height":27,"width":29};